export const snakeToTitle = (s: string): string => {
  return s.replace(/^_*(.)|_+(.)/g, (s, c, d) =>
    c ? c.toUpperCase() : " " + d.toUpperCase()
  );
};

export const underscoreToSpace = (s?: string | null): string =>
  s?.replace(/_/g, " ") ?? "";

export const checkForUndefinedAndNull = (s: any) => {
  return s !== undefined && s !== null;
};

export const getAddressString = (currentAddress: string): string => {
  try {
    const addressObj = JSON.parse(currentAddress);
    if (addressObj && Object.keys(addressObj)?.length) {
      const { line1, line2, city, state, pincode } = addressObj;
      const addressParts = [line1, line2, city, state, pincode].filter(Boolean);
      return addressParts.join(", ");
    }

    return "";
  } catch (ex) {
    console.error(new Error(ex).message);
    return "";
  }
};

export const getAddressType = (currentAddress: string): string => {
  try {
    const addressObj = JSON.parse(currentAddress);
    if (addressObj && Object.keys(addressObj)?.length) {
      const { additionalPermanentAddressType } = addressObj;
      return additionalPermanentAddressType;
    }
    return "";
  } catch (ex) {
    console.error(new Error(ex).message);
    return "";
  }
};

export const getAdditionalAddressString = (currentAddress: any) => {
  if (currentAddress) {
    const { line1, line2, city, state, pincode } = currentAddress;
    const addressParts = [line1, line2, city, state, pincode].filter(Boolean);
    return addressParts.join(", ");
  }
  return "";
};

export const getAddditonalAddressType = (currentAddress: any) => {
  if (currentAddress) {
    const { businessAddressType } = currentAddress;
    return businessAddressType || "";
  }
  return "";
};
export const getAddditonalAddressCategoryType = (currentAddress: any) => {
  if (currentAddress) {
    const { addressCategory } = currentAddress;
    return addressCategory || "";
  }
  return "";
};

export const getNotificationText = (uploadedMediaIDs: string[]) =>
  `${uploadedMediaIDs.length} document${uploadedMediaIDs.length > 1 ? "s" : ""} uploaded successfully`;
